import pages from './pages';
import games from '../games';
import presentations from '../presentation';

import _ from 'lodash';
var config = {};
/**
 * sortowanie stron po id
 * @type {Object}
 */
config = _.sortBy(pages, ['id']);

/**
 * dodanie do pliku konfiguracyjnego dodatkowych informacji dla gier:
 *  - assety
 *  - typ silnika
 */
config = _.map(config, (page) => {
  if (page.games.length > 0 || page.presentation.length > 0) {
    let extendetPage = page;
    extendetPage.games = _.map(page.games, (item) => {
      if (item.items) {
        item.items = item.items.map((o) => {
          let gameData = _.find(games, (game) => {
            return game.id === o.id;
          });
          if (!_.isUndefined(gameData)) {
            o = _.extend(o, {
              item: _.omit(gameData, ['id', 'pageId']),
            });
          }
          return o;
        });
      } else {
        let gameData = _.find(games, (game) => {
          return game.id === item.id;
        });
        if (!_.isUndefined(gameData)) {
          item = _.extend(item, {
            item: _.omit(gameData, ['id', 'pageId']),
          });
        }
      }
      return item;
    });
    // console.log('page.presentation', page.presentation);
    extendetPage.presentation = _.map(page.presentation, (item) => {
      let presentationData = _.find(presentations, (presentation) => {
        return presentation.id === item.id;
      });
      if (!_.isUndefined(presentationData)) {
        item = _.extend(item, {
          item: _.omit(presentationData, ['id', 'pageId']),
        });
      }
      return item;
    });
    return extendetPage;
  }
  return page;
});
console.log('config', config);
let dataObj = [];

let pageData = {};
let id = 1;
/**
 * układanie stron po 2 na rozkladowke
 */
_.each(config, function (item, index) {
  /**
   * sprawdza czy jest strony sa okładkami
   * @method if
   * @param  {Boolean} item.start prawda jesli jest przednią okładką
   * @param  {Boolean} item.stop prawda jesli jest tylna okładką
   */
  if (item.start) {
    pageData.start = item.start;
    pageData.right = item;
    pageData.id = 0;
    dataObj.push(pageData);
    pageData = {};
  } else if (item.stop) {
    pageData.stop = item.stop;
    pageData.left = item;
    pageData.id = id++;
    dataObj.push(pageData);
    pageData = {};
  } else {
    if (index % 2 === 0) {
      pageData.right = item;
      pageData.id = id++;
      dataObj.push(pageData);
      pageData = {};
    }
    pageData.left = item;
  }
});

export default dataObj;
